module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('audio', {
    ref: "audio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "controls": ""
    }
  }, [(_vm.$store.getters.audio) ? _c('source', {
    attrs: {
      "src": _vm.src,
      "type": "audio/mpeg"
    }
  }) : _vm._e(), _vm._v("\n            Your browser does not support the audio element.\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0670e6cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/AppPlayer.vue
// module id = 340
// module chunks = 0